var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"manager-section-list",attrs:{"id":"manager-section-list"}},[_c('v-row',[_c('v-col',{staticClass:"scroll-container",attrs:{"id":"scroll-section"}},[_c('Items',{ref:"sections"}),_c('Control')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }